import { format } from 'date-fns';
import { DATE_FORMATTING_PIPE, DATE_TIME_FORMATTING_PIPE } from '../constants';

export const formatDateDbToForm = (fieldValue: string): string =>
	format(new Date(String(fieldValue)), DATE_FORMATTING_PIPE);

export const formatDateTimeDbToForm = (fieldValue: string): string =>
	format(new Date(String(fieldValue)), DATE_TIME_FORMATTING_PIPE);
